var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueMarkdown',{class:[
    _vm.base.content,
    _vm.type[_vm.font],
    _vm.type[_vm.weight],
    _vm.type[_vm.typeScaleClass(_vm.size)]
  ],attrs:{"source":_vm.content}})}
var staticRenderFns = []

export { render, staticRenderFns }